import script from "./ScreenTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenTile.vue?vue&type=script&setup=true&lang=js"

import "./ScreenTile.vue?vue&type=style&index=0&id=49056ef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49056ef0"]])

export default __exports__